import { render, staticRenderFns } from "./exchangeRecord.vue?vue&type=template&id=1faedfcc&"
import script from "./exchangeRecord.vue?vue&type=script&lang=js&"
export * from "./exchangeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1faedfcc')) {
      api.createRecord('1faedfcc', component.options)
    } else {
      api.reload('1faedfcc', component.options)
    }
    module.hot.accept("./exchangeRecord.vue?vue&type=template&id=1faedfcc&", function () {
      api.rerender('1faedfcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotOrder/exchangeRecord/exchangeRecord.vue"
export default component.exports